import type * as React from 'react';
import { IBuilderStatsStats } from '../../types/newbuilding/builder';
import { withEmptyRendering } from '../../utils/hoc/withEmptyRendering';
import { Brief } from './Brief';
import * as styles from './BuilderStats.css';

interface IBuilderStatsProps {
  done?: IBuilderStatsStats | null;
  inProgress?: IBuilderStatsStats | null;
}

export function BuilderStatsComponent({ done, inProgress }: IBuilderStatsProps): React.JSX.Element {
  return (
    <div className={styles['container']}>
      {done && (
        <div className={styles['item']}>
          <Brief
            label="Сдано"
            value={
              <div className={styles['item_value']}>
                <div className={styles['house']}>
                  {done.housesCount}&nbsp;{done.housesText}
                </div>
                <div className={styles['newbuilding']}>{done.newbuildingText} </div>
              </div>
            }
          />
        </div>
      )}
      {inProgress && (
        <div className={styles['item']}>
          <Brief
            label="Строится"
            value={
              <div className={styles['item_value']}>
                <div className={styles['item_value']}>
                  {/*{stats.inProgress.housesCount} {stats.inProgress.housesText} {stats.inProgress.newbuildingText}*/}
                  <div className={styles['house']}>
                    {inProgress.housesCount}&nbsp;{inProgress.housesText}
                  </div>
                  <div className={styles['newbuilding']}>{inProgress.newbuildingText} </div>
                </div>
              </div>
            }
          />
        </div>
      )}
    </div>
  );
}

export function shouldHideBuilderStats(props: IBuilderStatsProps) {
  return !props.done && !props.inProgress;
}

export const BuilderStats = withEmptyRendering(shouldHideBuilderStats)(BuilderStatsComponent);
